export default __webpack_public_path__ + "static/3-847be1e70d47fd0f838c92c607920ca4.jpeg";